export default "__VITE_ASSET__C7iy4Uo5__"